import { flexCss, PropsType } from 'components/Column'
import styled from 'styled-components'

const Row = styled.div<PropsType>`
  ${flexCss};
`

export default Row
